import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { ModalFrame, ModalFrameFooter, ModalFrameInner } from 'components/modal';
import InfluencerPhoneDetails from '../influencer-phone-details/InfluencerPhoneDetails';
import InfluencerBusinessDetailsSettings from '../InfluencerBusinessDetailsSettings';
import BankDetailsSettings from '../../BankDetailsSettings';
import InfluencerShippingDetails from '../influencer-shipping-details/InfluencerShippingDetails';

import { __t, applyTranslations } from 'utils/language';

import type { Subcampaign } from 'types';

applyTranslations(require('./influencer-details-modal.i18n.json'));

type Props = {
  subcampaign: Subcampaign,
  type: 'phone_number' | 'business_details' | 'shipping_address' | 'bank_details',
  onCloseModal: () => void
};

class InfluencerDetailsModal extends React.PureComponent<Props> {
  renderModalBody(): React.ReactNode {
    const { type, subcampaign } = this.props;
    const { shippingAddress } = subcampaign;

    if (type === 'phone_number') {
      return (
        <InfluencerPhoneDetails
          phoneNumber={shippingAddress?.phone}
        />
      );
    }

    if (type === 'business_details') {
      return (
        <InfluencerBusinessDetailsSettings // @ts-ignore empty value is handled by isBusinessDetailsMissing
          values={subcampaign}
          centerAligned
          isBusinessDetailsMissing={!subcampaign.businessDetails?.registeredBusiness}
        />
      );
    }

    if (type === 'bank_details') {
      return (
        <BankDetailsSettings // @ts-ignore empty value is handled by isBankDetailsMissing
          values={subcampaign.bankDetails}
          centerAligned
          isBankDetailsMissing={!subcampaign.bankDetails?.accountNumber}
        />
      );
    }

    if (type === 'shipping_address' && subcampaign.shippingAddress) {
      return (
        <InfluencerShippingDetails
          values={subcampaign.shippingAddress}
          centerAligned
        />
      );
    }

    return null;
  }
  render(): React.ReactNode {
    const { type, onCloseModal } = this.props;

    return (
      <ModalFrame
        title={__t(`influencer_details_modal.title.${type}`)}
      >
        <ModalFrameInner>
          { this.renderModalBody() }
        </ModalFrameInner>
        <ModalFrameFooter>
          <ActionButton onClick={onCloseModal}>
            {__t('shipping_address_modal.button_close')}
          </ActionButton>
        </ModalFrameFooter>
      </ModalFrame>
    );
  }
}

export default InfluencerDetailsModal;
